import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import {CreateDisclosureSharedService, DropDownType, EntityNameChange} from '../../create-disclosure-shared.service';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {TemplateHeaderService} from '../template-header/template-header.service';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import {AppkitDropdownList} from '../template-sec8883-id215/template-sec8883-id215.component';
import { HttpErrorResponse } from '@angular/common/http';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import {stripAmountFormatting} from '../../dst-amount.util';
import {toSaveString, safeEntityField, safeEntityId} from '../../dst-save.util';

import { safeJsonInput } from '../../../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'dst-template-sec368-id188',
    templateUrl: './template-sec368-id188.component.html',
    styleUrls: ['../template-shared.scss', './template-sec368-id188.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec368Id188Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  // remove me after commit

  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form188!: UntypedFormGroup;
  selectedOption!: string;
  dcnId!: number;
  startLoader: boolean = false;
  statementId: string = '';
  attMap: { [key: string]: string[] } = {};
  editMode: boolean = false;
  target!: DSTEntityDetails | null;
  acquirer!: DSTEntityDetails | null;
  sHolder!: DSTEntityDetails | null;
  beginDate!: Date | string;
  endDate!: Date | string;

  showImport: boolean = false;
  showTotal: boolean = false;
  totalCalc: number = 0;

  Para1: string = '';
  codeSectionDropdown: AppkitDropdownList = [{value: -1, label: '** Please select a code section **', text: '** Please select a code section **'}];
  selectedCode: number = -1;
  selectedCodeItem: any = null;
  LiquidationDate1: any = '';
  showDate: any = {
    liqDate1: true,
    liqDate2: true,
  };
  LiquidationDate2: any = '';
  importationPropertyDesc: string = '';
  lossDuplicationPropertyDesc: string = '';
  gainLossPropertyDesc: string = '';
  selectedCurrency: number = -1;
  selectedCurrency2: number = -1;
  selectedBasis: number = -1;
  selectedBasisName: string = '';
  selectedCurrencyItem: any = null;
  selectedCurrencyItem2: any = null;
  selectedBasisItem: any = null;
  currencyOptions: any[] = [{index: '', value: -1, label: '** Select Currency **'}];
  currencyOptions2: any[] = [{index: '', value: -1, label: '** Select Currency **'}];
  propertyValBasisOptions: any[] = [{value: -1, label: '** Select a basis **', text: '** Select a basis **'}];

  selectedCurrency3: number = -1;
  selectedCurrency4: number = -1;
  selectedBasis2: number = -1;
  selectedBasisName2: string = '';
  selectedCurrencyItem3: any = null;
  selectedCurrencyItem4: any = null;
  selectedBasisItem2: any = null;
  currencyOptions3: any[] = [{index: '', value: -1, label: '** Select Currency **'}];
  currencyOptions4: any[] = [{index: '', value: -1, label: '** Select Currency **'}];
  propertyValBasisOptions2: any[] = [{value: -1, label: '** Select a basis **', text: '** Select a basis **'}];

  stocksSecurityPropertyDesc: string = '';
  PLR: string = 'None.';
  section4text: string = '';

  showDREMsg: boolean = false;
  DREMsg: string = '';

  headerOptions: any[] = [
    {value: 0, label: '-'},
    {value: 1, label: '(a)'}
  ];
  headerOptionVal: string = '';
  entityNameChangeOnDate: boolean = false;
    nameChangeChecked: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private headerService: TemplateHeaderService,
              private trackerTabsService: TrackerTabsService,
              private cdref: ChangeDetectorRef) {
  }

  get additionalPropsDetails(): UntypedFormArray {
    return this.form188.get('main')?.get('additionalPropsDetails') as UntypedFormArray;
  }

  get additionalPropsDetails2(): UntypedFormArray {
    return this.form188.get('main')?.get('additionalPropsDetails2') as UntypedFormArray;
  }

  ngOnInit(): void {
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    this.form188 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      main: this.formBuilder.group({
        Para1: [''],
        LiquidationDate1: [''],
        LiquidationDate2: [''],
        importationPropertyDesc: [''],
        lossDuplicationPropertyDesc: [''],
        gainLossPropertyDesc: [''],
        propertyValBasis: [''],
        currency1: [''],
        currency2: [''],
        additionalPropsDetails: this.formBuilder.array([
          this.formBuilder.group({
            description: [''],
            transferorBasis: [''],
            fairMarketVal: ['']
          })
        ]),
        stocksSecurityPropertyDesc: [''],
        PLR: [''],
        section4text: [''],
        propertyValBasis2: [''],
        currency3: [''],
        currency4: [''],
        additionalPropsDetails2: this.formBuilder.array([
          this.formBuilder.group({
            description: [''],
            transferorBasis: [''],
            fairMarketVal: ['']
          })
        ]),
      })
    });

    this.sharedService.getLiquidationStateDropdown(4).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.codeSectionDropdown.push({
            value: element.id,
            label: element.text,
            text: element.text
          });
        });
        this.codeSectionDropdown = JSON.parse(JSON.stringify(this.codeSectionDropdown));
      }, () => {

      }, () => {
        if (this.attMap['CodeSection']) {
          const updatedData = this.updateDropdownList(this.codeSectionDropdown, this.attMap['CodeSection'][0]);
          this.codeSectionDropdown = updatedData.dropdownData;
          this.codeSectionDropdown = JSON.parse(JSON.stringify(this.codeSectionDropdown));
          this.selectedCode = updatedData.index;
          this.selectedCodeItem = this.codeSectionDropdown.find((i: any) => i.selected) || null;
        }
      });
    this.sharedService.getBasisDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.propertyValBasisOptions.push({
            value: element.id,
            label: element.text,
            text: element.text,
            selected: false //element.id === 3 // default to GAAP
          });
          this.propertyValBasisOptions2.push({
            value: element.id,
            label: element.text,
            text: element.text,
            selected: false //element.id === 3 // default to GAAP
          });
        });
        this.propertyValBasisOptions = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions), null, 'template-sec368-id188.parse1');
        this.propertyValBasisOptions2 = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions2), null, 'template-sec368-id188.parse2');
      }, () => {

      }, () => {
        this.applyBasisSelectionsFromAttMap();
      });

    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach((element, index) => {
          this.currencyOptions.push({
            value: element.id,
            label: element.text,
            index: index,
          });
          this.currencyOptions2.push({
            value: element.id,
            label: element.text,
            index: index,
          });
          this.currencyOptions3.push({
            value: element.id,
            label: element.text,
            index: index,
          });
          this.currencyOptions4.push({
            value: element.id,
            label: element.text,
            index: index,
          });
        });
        const usdIndex: number = this.currencyOptions.findIndex((c: any) => c.value === 84);
        if (usdIndex > 0) {
          this.currencyOptions[usdIndex].selected = true;
          this.currencyOptions2[usdIndex].selected = true;
          this.currencyOptions3[usdIndex].selected = true;
          this.currencyOptions4[usdIndex].selected = true;
          this.currencyOptions = safeJsonInput<any>(JSON.stringify(this.currencyOptions), null, 'template-sec368-id188.parse4');
          this.currencyOptions2 = safeJsonInput<any>(JSON.stringify(this.currencyOptions2), null, 'template-sec368-id188.parse5');
          this.currencyOptions3 = safeJsonInput<any>(JSON.stringify(this.currencyOptions3), null, 'template-sec368-id188.parse6');
          this.currencyOptions4 = safeJsonInput<any>(JSON.stringify(this.currencyOptions4), null, 'template-sec368-id188.parse7');
          this.selectedCurrency = this.currencyOptions[usdIndex].value;
          this.selectedCurrency2 = this.currencyOptions2[usdIndex].value;
          this.selectedCurrency3 = this.currencyOptions3[usdIndex].value;
          this.selectedCurrency4 = this.currencyOptions4[usdIndex].value;
          this.selectedCurrencyItem = this.currencyOptions[usdIndex];
          this.selectedCurrencyItem2 = this.currencyOptions2[usdIndex];
          this.selectedCurrencyItem3 = this.currencyOptions3[usdIndex];
          this.selectedCurrencyItem4 = this.currencyOptions4[usdIndex];
        }
      }, () => {

      }, () => {
        if (this.attMap['Currency']) {
          this.attMap['Currency'].forEach((element: any, index: number) => {
            switch (index) {
              case 0:
                let updatedData = this.updateDropdownList(this.currencyOptions, element);
                this.currencyOptions = updatedData.dropdownData;
                this.selectedCurrency = updatedData.index;
                this.selectedCurrencyItem = this.currencyOptions.find((i: any) => i.selected) || null;
                break;
              case 1:
                const updatedData2 = this.updateDropdownList(this.currencyOptions2, element);
                this.currencyOptions2 = updatedData2.dropdownData;
                this.selectedCurrency2 = updatedData2.index;
                this.selectedCurrencyItem2 = this.currencyOptions2.find((i: any) => i.selected) || null;
                break;
              case 2:
                const updatedData3 = this.updateDropdownList(this.currencyOptions3, element);
                this.currencyOptions3 = updatedData3.dropdownData;
                this.selectedCurrency3 = updatedData3.index;
                this.selectedCurrencyItem3 = this.currencyOptions3.find((i: any) => i.selected) || null;
                break;
              case 3:
                const updatedData4 = this.updateDropdownList(this.currencyOptions4, element);
                this.currencyOptions4 = updatedData4.dropdownData;
                this.selectedCurrency4 = updatedData4.index;
                this.selectedCurrencyItem4 = this.currencyOptions4.find((i: any) => i.selected) || null;
                break;
            }
          });
        }
      });
  }

  ngAfterViewInit(): void {
    // Avoid ExpressionChangedAfterItHasBeenCheckedError when loadStmtData mutates
    // view-bound flags (e.g. `nameChangeChecked`) during the same change-detection
    // pass as AfterViewInit.
    setTimeout(() => {
      this.loadStmtData();
    });
  }

  private loadStmtData(): void {
    const data: StmtData | undefined = this.sharedService.getFormData(188);
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.primaryleid);
              break;
            case 1:
              element.fillLEID(data.secondaryleid);
              break;
            case 2:
              if (this.attMap['SHdspTransferorLEID'] && this.attMap['SHdspTransferorLEID'][0]) {
                this.sharedService.getDSTEntityInfo(this.attMap['SHdspTransferorLEID'][0]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any[]) => {
                  element.fillLEID(data[0].LEID);
                });
              }
              break;
          }
        });
      },1000);

      this.populateFields(data);

    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      const formId = this.sharedService.getActiveFormState().formId;
      const taxYear = (this.sharedService.getActiveFormState()?.taxYear || 2020).toString();
      const cseId = this.sharedService.getActiveFormState().cseId;

      setTimeout(() => {
        this.leidComponents.toArray()[0].fillLEID(this.sharedService.leid);
        this.sharedService.checkImportBtnRequired(this.sharedService.leid, (this.sharedService.getActiveFormState()?.taxYear || 2020).toString(), this.sharedService.csStatementId.toString()).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data: boolean) => {
            this.showImport = data;
          }, () => {

          }, () => {

          });
      });

      this.startLoader = true;
      this.sharedService.getDSTTrackerRequirementData(taxYear, cseId, formId!).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: StmtData) => {
        data && this.populateFields(data);
      }, () => { this.startLoader = false; }, () => { this.startLoader = false; });
    }else{
      this.nameChangeChecked = true;
    }
  }
  populateFields(data: StmtData) {
    data.children?.forEach((stmt: StmtAttrData) => {
      if (this.attMap[stmt.attributeName] == undefined) {
        this.attMap[stmt.attributeName] = [];
      }
      // Keep a slot for a missing value so Description, basis, and FMV stay on the same row.
      this.attMap[stmt.attributeName].push(stmt.attributeValue ?? '');
    });
    if (this.attMap['LiquidationDate']) {
      this.attMap['LiquidationDate'].forEach((element: any, index: number) => {
        switch (index) {
          case 0:
            if (element !== '' && element !== undefined) {
              this.LiquidationDate1 = new Date(element.replace(/-/g, '\/').replace(/T.+/, ''));
            }
            break;

          case 1:
            if (element !== '' && element !== undefined) {
              this.LiquidationDate2 = new Date(element.replace(/-/g, '\/').replace(/T.+/, ''));
            }
            break;
        }
      });
    }

    this.applyPropRows('additionalPropsDetails', 'Desc', 'BasisAmt', 'FMVAmt');
    this.applyPropRows('additionalPropsDetails2', 'Desc1', 'BasisAmt1', 'FMVAmt1');
    if (this.attMap['Para1']) {
      this.Para1 = this.attMap['Para1'][0] ?? '';
    }
    if (this.attMap['importationPropertyDesc']) {
      this.importationPropertyDesc = this.attMap['importationPropertyDesc'][0] ?? '';
    }
    if (this.attMap['lossDuplicationPropertyDesc']) {
      this.lossDuplicationPropertyDesc = this.attMap['lossDuplicationPropertyDesc'][0] ?? '';
    }
    if (this.attMap['gainLossPropertyDesc']) {
      this.gainLossPropertyDesc = this.attMap['gainLossPropertyDesc'][0] ?? '';
    }
    if (this.attMap['stocksSecurityPropertyDesc']) {
      this.stocksSecurityPropertyDesc = this.attMap['stocksSecurityPropertyDesc'][0] ?? '';
    }
    if (this.attMap['PLR']) {
      this.PLR = this.attMap['PLR'][0] ?? '';
    }
    if (this.attMap['section4text']) {
      this.section4text = this.attMap['section4text'][0] ?? '';
    }
    this.applyBasisSelectionsFromAttMap();
    this.cdref.detectChanges();
  }

  /**
   * Write saved description / amount rows onto the form array the inputs are
   * already bound to. Replacing the array leaves the first input on the
   * original empty group, so that row stays blank in edit mode.
   */
  private applyPropRows(arrayName: string, descKey: string, basisKey: string, fmvKey: string): void {
    const descriptions: string[] = this.attMap[descKey] || [];
    const basis: string[] = this.attMap[basisKey] || [];
    const fairMarket: string[] = this.attMap[fmvKey] || [];
    const count = Math.max(descriptions.length, basis.length, fairMarket.length);
    if (!count) {
      return;
    }
    const formArray = this.form188.get('main')?.get(arrayName) as UntypedFormArray;
    if (!formArray) {
      return;
    }
    while (formArray.length < count) {
      formArray.push(this.formBuilder.group({
        description: [''],
        transferorBasis: [''],
        fairMarketVal: ['']
      }));
    }
    while (formArray.length > count) {
      formArray.removeAt(formArray.length - 1);
    }
    const writeRows = () => {
      for (let index = 0; index < count; index++) {
        formArray.at(index)?.patchValue({
          description: descriptions[index] ?? '',
          transferorBasis: stripAmountFormatting(basis[index]),
          fairMarketVal: stripAmountFormatting(fairMarket[index])
        });
      }
    };
    writeRows();
    // AppKit projects the input after the first write, so write the saved
    // values again once each row's field exists.
    setTimeout(() => {
      writeRows();
      this.cdref.detectChanges();
    });
  }

  private applyBasisSelectionsFromAttMap(): void {
    if (!this.attMap['Basis'] || this.propertyValBasisOptions.length <= 1) {
      return;
    }
    this.attMap['Basis'].forEach((element: any, index: number) => {
      switch (index) {
        case 0: {
          const updatedData = this.updateDropdownList(this.propertyValBasisOptions, element);
          this.propertyValBasisOptions = JSON.parse(JSON.stringify(updatedData.dropdownData));
          this.selectedBasis = updatedData.index;
          this.selectedBasisItem = this.propertyValBasisOptions.find((i: any) => i.selected) || null;
          this.selectedBasisName = this.selectedBasisItem?.text ?? this.selectedBasisItem?.label ?? '';
          break;
        }
        case 1: {
          const updatedData2 = this.updateDropdownList(this.propertyValBasisOptions2, element);
          this.propertyValBasisOptions2 = JSON.parse(JSON.stringify(updatedData2.dropdownData));
          this.selectedBasis2 = updatedData2.index;
          this.selectedBasisItem2 = this.propertyValBasisOptions2.find((i: any) => i.selected) || null;
          this.selectedBasisName2 = this.selectedBasisItem2?.text ?? this.selectedBasisItem2?.label ?? '';
          break;
        }
      }
    });
  }

  private extractDropdownSelection(event: any): any {
    if (!event?.selected) {
      return null;
    }
    return Array.isArray(event.selected) ? event.selected[0] : event.selected;
  }

  trackByDropdownValue(index: number, item: any): number | string {
    return item?.value ?? index;
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.target, this.acquirer, this.sHolder])) {
      return;
    }

    try {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.target),
        'secondaryEntityId': safeEntityId(this.acquirer),
        'branchEntityId': '',
        'comments': '',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'attachmentFileName': '',
      };
      const desc: string[] = [];
      const basisAmt: string[] = [];
      const fairMarketVal: string[] = [];
      this.additionalPropsDetails.controls.forEach(element => {
        desc.push(element.value.description);
        basisAmt.push(element.value.transferorBasis !== null ? stripAmountFormatting(element.value.transferorBasis.toString()) : '');
        fairMarketVal.push(element.value.fairMarketVal !== null ? stripAmountFormatting(element.value.fairMarketVal.toString()) : '');
      });
      const desc2: string[] = [];
      const basisAmt2: string[] = [];
      const fairMarketVal2: string[] = [];
      this.additionalPropsDetails2.controls.forEach(element => {
        desc2.push(element.value.description);
        basisAmt2.push(element.value.transferorBasis !== null ? stripAmountFormatting(element.value.transferorBasis.toString()) : '');
        fairMarketVal2.push(element.value.fairMarketVal !== null ? stripAmountFormatting(element.value.fairMarketVal.toString()) : '');
      });

      const jsonObject = {
        'statementOption': this.selectedOption === '-' ? '' : this.selectedOption,
        'SHLEID': safeEntityField(this.sHolder, 'LEID'),
        'SHdspTransferorLEID': safeEntityField(this.sHolder, 'ENTITYID'),
        'SHBusiness': safeEntityField(this.sHolder, 'BUSINESSID'),
        'Para1': toSaveString(this.Para1),
        'CodeSection': this.selectedCode != null ? toSaveString(this.selectedCode) : '',
        'LiquidationDate': [this.formatDateForSave(this.LiquidationDate1), this.formatDateForSave(this.LiquidationDate2)],
        'importationPropertyDesc': toSaveString(this.importationPropertyDesc),
        'lossDuplicationPropertyDesc': toSaveString(this.lossDuplicationPropertyDesc),
        'gainLossPropertyDesc': toSaveString(this.gainLossPropertyDesc),
        'Basis': [toSaveString(this.selectedBasis), toSaveString(this.selectedBasis2)],
        'Currency': [toSaveString(this.selectedCurrency), toSaveString(this.selectedCurrency2), toSaveString(this.selectedCurrency3), toSaveString(this.selectedCurrency4)],
        'Desc': desc.some((value) => value !== null && value !== undefined && value !== '') ? desc : [''],
        'BasisAmt': basisAmt,
        'FMVAmt': fairMarketVal,
        'stocksSecurityPropertyDesc': toSaveString(this.stocksSecurityPropertyDesc),
        'Desc1': desc2.some((value) => value !== null && value !== undefined && value !== '') ? desc2 : [''],
        'BasisAmt1': basisAmt2,
        'FMVAmt1': fairMarketVal2,
        'PLR': toSaveString(this.PLR),
        'section4text': toSaveString(this.section4text)
      };

      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.startLoader = false;
          this.sharedService.setSavedStatementId(data.statementId);
          const childStatements = data.childStatement;
          if (childStatements?.length) {
            this.sharedService.openChildStatements(childStatements, this.onSave);
            trackerTab.parentTransDate = this.formatDateForSave(this.LiquidationDate1);
          } else {
            this.sharedService.switchTemplateMode(true);
            this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
          }
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error occurred while saving. Please try again.');
        this.startLoader = false;
      });
    } catch (error) {
      console.error('Error preparing Section 368 form save payload:', error);
      this.startLoader = false;
      this.dstSharedService.showAlert('error', 'Error occurred while saving. Please verify all required fields and try again.');
    }
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  onTargetChanged(selectedTarget: DSTEntityDetails | null): void {
    this.target = selectedTarget;
    this.showImport = true;
    this.headerComponent.loadConsolGroups(selectedTarget?.LEID!,this.dcnId);
    // check for DRE entities
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.target, this.acquirer, this.sHolder]);
    this.showDREMsg = !!this.DREMsg;
    // check for name change
    if (this.LiquidationDate1 && this.target?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.target.LEID,
        this.sharedService.getTransDateStr(this.LiquidationDate1,1),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.target!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.target!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error?.message || 'Something went wrong while checking entity name change.');
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.LiquidationDate1) {
      this.nameChangeChecked = true;

    } else {
      this.entityNameChangeOnDate = false;
    }
  }

  onAcquirerChanged(selectedAcquirer: DSTEntityDetails | null): void {
    this.acquirer = selectedAcquirer;
    // check for DRE entities
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.acquirer, this.target, this.sHolder]);
    this.showDREMsg = !!this.DREMsg;
    // check for name change
    if (this.LiquidationDate1 && this.acquirer?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.acquirer.LEID,
        this.sharedService.getTransDateStr(this.LiquidationDate1,1),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.acquirer!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.acquirer!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error?.message || 'Something went wrong while checking entity name change.');
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.LiquidationDate1) {
      this.nameChangeChecked = true;

    } else {
      this.entityNameChangeOnDate = false;
    }
  }

  onSHolderChanged(selectedSHolder: DSTEntityDetails | null): void {
    this.sHolder = selectedSHolder;
    // check for DRE entities
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.sHolder, this.target, this.acquirer]);
    this.showDREMsg = !!this.DREMsg;
    // check for name change
    if (this.LiquidationDate1 && this.sHolder?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.sHolder.LEID,
        this.sharedService.getTransDateStr(this.LiquidationDate1,1),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.sHolder!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.sHolder!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error?.message || 'Something went wrong while checking entity name change.');
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.LiquidationDate1) {
      this.nameChangeChecked = true;

    } else {
      this.entityNameChangeOnDate = false;
    }
  }

  updateDropdownList(currentOptions: any[], element: string) {
    const updateList: any[] = [];
    let selectedIndex = -1;
    currentOptions.forEach((el: any, index: number) => {
      const displayText = el.text ?? el.label;
      if (parseInt(element) === el.value) {
        updateList.push({
          value: el.value,
          label: displayText,
          text: displayText,
          index: index,
          selected: true,
        });
        selectedIndex = el.value;
      } else {
        updateList.push({
          value: el.value,
          label: displayText,
          text: displayText,
          index: index,
        });
      }
    });
    return {dropdownData: updateList, index: selectedIndex};
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  onFormOptionChanged(selectedOptionID: number): void {
    const selected: any = this.headerOptions.find((o: any) => {
      return o.value === selectedOptionID || o.id === selectedOptionID;
    });
    this.selectedOption = selected?.label ?? selected?.text;
  }

  codeSelected(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCode = change?.value;
    this.selectedCodeItem = change;
  }

  dateChange(event: any, index: number) {
    switch (index) {
      case 1: {
        this.LiquidationDate1 = event.startDate.format('YYYY-MM-DD');
        const leids: string = this.sharedService.concatLEIDs([this.target!, this.acquirer!, this.sHolder!]);
        if (!leids) {
          break;
        }
        this.startLoader = true;
        this.entityNameChangeOnDate = true;
        this.sharedService.checkForEntityNameChange(this.statementId,
          leids,
          this.sharedService.getTransDateStr(this.LiquidationDate1,1),
          this.sharedService.getActiveFormState().taxYear.toString()
        ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
          if (response) {
            for (let i = 0; i < leids.split(',').length; i++) {
              this.sharedService.updateEntityName(response[i].LEID,
                response[i].LE_NAME, [this.target!, this.acquirer!, this.sHolder!], response[i].TAXTYPECODE);
            }
          }
            this.nameChangeChecked = true;
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.dstSharedService.showAlert('error', error?.message || 'Something went wrong while checking entity name change.');
        }).add(() => {
          this.startLoader = false;
        });
        break;
      }
      case 2: {
        this.LiquidationDate2 = event.startDate.format('YYYY-MM-DD');
        this.PLR = '';
        break;
      }
      default:
        break;
    }
  }

  clearDate(index: number): void {
    switch (index) {
      case 1: {
        this.showDate.liqDate1 = false;
        this.LiquidationDate1 = '';
        setTimeout(() => {
          this.showDate.liqDate1 = true;
        });
        break;
      }
      case 2: {
        this.showDate.liqDate2 = false;
        this.LiquidationDate2 = '';
        setTimeout(() => {
          this.showDate.liqDate2 = true;
        });
        break;
      }
      default:
        break;
    }
    
    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 100);
  }

  /**
   * 🚀 CRITICAL: Force clear date picker input fields using DOM manipulation
   * This is a fallback method for stubborn date picker components
   */
  private forceClearDatePickerInputs(index: number): void {
    try {
      // Find the date picker input field by form control name
      const formControlNames = ['LiquidationDate1', 'LiquidationDate2'];
      const formControlName = formControlNames[index - 1];
      
      if (formControlName) {
        // Try to find the input field within the date picker component
        const datePickerElement = document.querySelector(`[formcontrolname="${formControlName}"]`);
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input');
          if (inputElement && inputElement.value) {
            // Clear the input value and trigger change event
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  dummyFunc(event: Event): void {

  }

  addAdditionalPropDetails(): void {
    this.additionalPropsDetails.push(this.formBuilder.group({
      description: [''],
      transferorBasis: [''],
      fairMarketVal: ['']
    }));
  }

  removeAdditionalPropDetailsAt(index: number): void {
    this.additionalPropsDetails.removeAt(index);
  }

  addAdditionalPropDetails2(): void {
    this.additionalPropsDetails2.push(this.formBuilder.group({
      description: [''],
      transferorBasis: [''],
      fairMarketVal: ['']
    }));
  }

  removeAdditionalPropDetailsAt2(index: number): void {
    this.additionalPropsDetails2.removeAt(index);
  }

  currencyOneChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency = change?.value;
    this.selectedCurrencyItem = change;
    this.currencyOptions2 = safeJsonInput<any>(JSON.stringify(this.currencyOptions), null, 'template-sec368-id188.parse8');
    this.selectedCurrency2 = change?.value;
    this.selectedCurrencyItem2 = this.currencyOptions2.find((i: any) => i.value === change?.value) || null;
  }

  currencyTwoChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency2 = change?.value;
  }

  selectBasisOption(event: any) {
    const change = this.extractDropdownSelection(event);
    if (!change) {
      return;
    }
    this.selectedBasis = change.value;
    this.selectedBasisName = change.text ?? change.label ?? '';
    this.selectedBasisItem = this.propertyValBasisOptions.find((i: any) => i.value === change.value) ?? change;
    this.cdref.detectChanges();
  }

  currencyOneChange2(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency3 = change?.value;
    this.selectedCurrencyItem3 = change;
    this.currencyOptions4 = safeJsonInput<any>(JSON.stringify(this.currencyOptions3), null, 'template-sec368-id188.parse9');
    this.selectedCurrencyItem4 = this.currencyOptions4.find((i: any) => i.value === change?.value) || null;
  }

  currencyTwoChange2(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency4 = change?.value;
  }

  selectBasisOption2(event: any) {
    const change = this.extractDropdownSelection(event);
    if (!change) {
      return;
    }
    this.selectedBasis2 = change.value;
    this.selectedBasisName2 = change.text ?? change.label ?? '';
    this.selectedBasisItem2 = this.propertyValBasisOptions2.find((i: any) => i.value === change.value) ?? change;
    this.cdref.detectChanges();
  }

  onChangeNumber(event: any, index: number): void {
    const numeric = String(event?.value ?? '').replace(/[^0-9.-]/g, '');
    this.additionalPropsDetails.at(index).get('fairMarketVal')?.setValue(numeric);
  }

  onChangeNumber2(event: any, index: number): void {
    const numeric = String(event?.value ?? '').replace(/[^0-9.-]/g, '');
    this.additionalPropsDetails2.at(index).get('fairMarketVal')?.setValue(numeric);
  }

  import(): void {
    this.startLoader = true;
    this.sharedService.getImport(this.target?.LEID, this.sharedService.getActiveFormState()?.taxYear, this.sharedService.getTransDateStr(this.LiquidationDate1)).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data.length) {
          this.additionalPropsDetails.clear();
          data.forEach((element: any) => {
            this.additionalPropsDetails.push(this.formBuilder.group({
              description: [element.DESCRIPTION],
              transferorBasis: [element.AMOUNTS],
              fairMarketVal: [element.AMOUNTS]
            }));
            this.totalCalc += element.AMOUNTS;
          });
          this.showImport = false;
          this.showTotal = true;
          this.propertyValBasisOptions[1].selected = true;
          this.selectedBasis = this.propertyValBasisOptions[1].value;
          this.selectedBasisItem = this.propertyValBasisOptions[1];
        }
        this.startLoader = false;
      }, () => {

      }, () => {

      });
  }

  total(event: any): void {
    this.additionalPropsDetails.clear();
    const isChecked = event?.checkboxState ?? event?.srcElement?.checked ?? false;
    if (isChecked) {
      this.additionalPropsDetails.push(this.formBuilder.group({
        description: ['Net Assets'],
        transferorBasis: [this.totalCalc],
        fairMarketVal: [this.totalCalc]
      }));
    } else {
      this.totalCalc = 0;
      this.import();
    }
  }

  isFormValid(placeholder: boolean): boolean {
    if (!this.dcnId || this.dcnId <= 0) {
      this.dstSharedService.showAlert('error', 'Please select a consolidate group from the form header');
      return false;
    }
    if (placeholder) {
      if (!this.target) {
        this.dstSharedService.showAlert('error', 'Please specify the Target');
        return false;
      }
    } else {
      if (!this.target) {
        this.dstSharedService.showAlert('error', 'Please specify the Target');
        return false;
      }
      if (!this.acquirer) {
        this.dstSharedService.showAlert('error', 'Please specify the Acquirer');
        return false;
      }
      if (this.selectedCode === -1) {
        this.dstSharedService.showAlert('error', 'Please select a code section');
        return false;
      }
      if (this.isLiquidationDateEmpty()) {
        this.dstSharedService.showAlert('error', 'Please select Date of reorganization');
        return false;
      }
      if (this.selectedCurrency === -1) {
        this.dstSharedService.showAlert('error', 'Please select Fair Market value Currency type');
        return false;
      }
      if (this.selectedBasis === -1) {
        this.dstSharedService.showAlert('error', 'Please select a Basis section');
        return false;
      }
      if (this.selectedCurrency2 === -1) {
        this.dstSharedService.showAlert('error', 'Please select Fair Market value Currency type');
        return false;
      }
      if (this.sHolder && this.selectedBasis2 === -1) {
        this.dstSharedService.showAlert('error', 'Please select a Basis section');
        return false;
      }
    }

    return true;
  }

  isLiquidationDateEmpty(): boolean {
    if (this.LiquidationDate1 == null || this.LiquidationDate1 === '') {
      return true;
    }
    if (this.LiquidationDate1 instanceof Date) {
      return isNaN(this.LiquidationDate1.getTime());
    }
    return false;
  }

  private formatDateForSave(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.formatDateToYMD(value);
    }
    if (value.startDate && typeof value.startDate.format === 'function') {
      return value.startDate.format('YYYY-MM-DD');
    }
    if (typeof value === 'string') {
      const normalized = value.replace(/T.+/, '').trim();
      return normalized.length >= 10 ? normalized.substring(0, 10) : normalized;
    }
    return '';
  }

  private formatDateToYMD(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.text || item?.label || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }

}
